import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import SystemDataService from "../../../services/KangarooServices/SystemDataService";
import { useNavigate, useParams } from "react-router-dom";
import { formatDateTime } from "../../../Components/Common/FormatDate";

const PrivacyDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [defaultData, setDefaultData] = useState();
  const fetchDetail = async () => {
    try {
      const response = await SystemDataService.getDetail(id);
      setDefaultData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDetail();
  }, [id]);
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title={defaultData?.heading} pageTitle="System Setup" />
        <Row className="justify-content-center">
          <Col lg={10}>
            <Card>
              <div className="bg-info-subtle position-relative">
                <CardBody className="card-body p-5">
                  <div className="text-center">
                    <h3>{defaultData?.heading}</h3>

                    <p className="mb-0 text-muted">
                      Last update: {formatDateTime(defaultData?.createdAt)}
                    </p>
                  </div>
                </CardBody>
                <div className="shape">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    // xmlns:svgjs="http://svgjs.com/svgjs"
                    width="1440"
                    height="60"
                    preserveAspectRatio="none"
                    viewBox="0 0 1440 60"
                  >
                    <g mask='url("#SvgjsMask1001")' fill="none">
                      <path
                        d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z"
                        style={{ fill: "var(--vz-secondary-bg)" }}
                      ></path>
                    </g>
                    <defs>
                      <mask id="SvgjsMask1001">
                        <rect width="1440" height="60" fill="#ffffff"></rect>
                      </mask>
                    </defs>
                  </svg>
                </div>
              </div>
              <CardBody className="card-body p-4">
                <div
                  dangerouslySetInnerHTML={{ __html: defaultData?.content }}
                />

                <div className="text-end">
                  <Button
                    className="btn-danger"
                    onClick={() => navigate("/system-setup")}
                  >
                    I Understand
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default PrivacyDetail;
